import { YARD_DAY_OPTIONS } from './helpers'

type YardDaySelectorProps = {
  yardDays: string[]
  hasRequiredYardDays: boolean
  disabled?: boolean
  onToggleYardDay: (day: string) => void
}

export function YardDaySelector({
  yardDays,
  hasRequiredYardDays,
  disabled = false,
  onToggleYardDay
}: YardDaySelectorProps) {
  return (
    <div className="rounded-[24px]">
      <h3 className="mb-1 text-base font-bold text-gray-dark">Yard Scheduled Days</h3>
      <p className="mb-4 text-sm text-gray-light">
        Select at least 2 preferred days for yard training.
      </p>
      <div className="grid grid-cols-2 gap-3">
        {YARD_DAY_OPTIONS.map(day => (
          <label
            key={day}
            className={`group relative flex min-h-[56px] w-full cursor-pointer items-center gap-2 rounded-2xl border px-3 py-3 transition-all ${
              yardDays.includes(day)
                ? 'border-primary bg-white shadow-[0_10px_24px_rgba(230, 83, 0,0.14)] ring-1 ring-primary/15'
                : 'border-[#eadfd2] bg-white/90 hover:-translate-y-0.5 hover:border-primary/45 hover:shadow-[0_10px_20px_rgba(102,72,34,0.08)]'
            }`}
          >
            <input
              type="checkbox"
              checked={yardDays.includes(day)}
              disabled={disabled}
              onChange={() => onToggleYardDay(day)}
              className="sr-only"
            />
            <span className="text-sm font-semibold text-gray-dark sm:text-[13px]">{day}</span>
          </label>
        ))}
      </div>
      {!hasRequiredYardDays && yardDays.length > 0 ? (
        <p className="mt-2 text-xs text-red-500">Please select at least 2 yard days to continue.</p>
      ) : null}
    </div>
  )
}
